import { gql } from '@apollo/client';

export const MERGE_CATEGORIES = gql`
  mutation CreateMergedCategory($attributes: MergedCategoryAttributes!) {
    createMergedCategory(attributes: $attributes) {
      cardSortMergedCategory {
        id
        name
      }
    }
  }
`;

export const UNMERGE_CATEGORIES = gql`
  mutation DeleteMergedCategory($attributes: UnmergeCategoryAttributes!) {
    deleteMergedCategory(attributes: $attributes) {
      void
    }
  }
`;

export const GET_ANALYTICS_CARD_SORT = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      cardSort {
        cardSortItem {
          id
          name
          description
          imageKey
          imageUrl
        }
        cardSortCategory {
          id
          name
        }
        cardSortMergedCategory {
          id
          name
        }
        frequencyPercentage
        frequencyTotal
      }
    }
  }
`;

export const GET_SIMILARITY_MATRIX = gql`
  query CardSortAnalytics($projectId: ID!, $segmentId: ID) {
    cardSortAnalytics(projectId: $projectId, segmentId: $segmentId) {
      similarityMatrix
      similarityMatrixLabels
      dendrogramImage
    }
  }
`;

export const PROCESS_SIMILARITY_MATRIX = gql`
  mutation ProcessSimilarityMatrix($projectId: ID!) {
    processSimilarityMatrix(projectId: $projectId) {
      projectId
    }
  }
`;
